import {useContext} from 'react';

import {ComparisonHoverContext} from '../components/ComparisonHoverContext';
import {ComparisonTestIdContext} from '../components/ComparisonTestIdContext';

export function useComparisonHover() {
  return {
    hasUnifiedSurfaces: useContext(ComparisonHoverContext),
    testId: useContext(ComparisonTestIdContext),
  };
}
